import { BankName, BankAbbreviations } from '@libs/backend-common';
export const detectBankFromIban = (iban) => {
    const abbreviation = (iban?.[4] +
        iban?.[5]);
    const code = BankAbbreviations[abbreviation];
    // BankCode enum's keys are the same as values
    return {
        code: code,
        name: BankName[code],
    };
};
//# sourceMappingURL=bank.js.map